import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../../../../../../../src/helpers/reselectHelpers';
import {openContactsManagerMergeContactsAsyncAction} from '../../../../../../../../../../src/store/panels/contacts/contactsManager/sidePanel/contactsManagerSidePanelActions';
import {ContactsTableMergeAction} from './contactsTableMergeAction';

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  openSidePanelAsync: openContactsManagerMergeContactsAsyncAction,
}));

export const ContactsTableMergeActionContainer = connect(null, mapDispatchToProps)(ContactsTableMergeAction);
